import React, { useState } from "react";
import {
  List,
  useTable,
  TableColumnType,
  Button,
  Table,
  SaveButton,
  Form,
  Input,
} from "@pankod/refine-antd";
import { useExport } from "@pankod/refine-core";
import { ISearch } from "type";

export const OtpList = () => {
  const [query, setQuery] = useState("");
  const { tableProps, searchFormProps } = useTable({
    queryOptions: { retry: false },
    onSearch: (values: ISearch) => {
      return [
        {
          field: "q",
          operator: "contains",
          value: values.q ? values.q : null,
        },
      ];
    },
  });
  const { triggerExport } = useExport({
    filters: [
      {
        field: "q",
        operator: "contains",
        value: query,
      },
    ],
  });
  const columns = React.useMemo<TableColumnType<any>[]>(
    () => [
      {
        dataIndex: "otp_id",
        title: "Otp Id",
        type: "number",
        width: 80,
        align: "center",
        headerAlign: "center",
        ellipsis: {
          showTitle: false,
        },
        fixed: "left",
      },
      {
        dataIndex: "email",
        title: "Email",
        width: 200,
      },
      {
        dataIndex: "otp",
        title: "Otp",
        width: 100,
      },
      {
        dataIndex: "ref",
        title: "Ref",
        width: 300,
      },
      {
        dataIndex: "action",
        title: "Action",
        width: 200,
      },
      {
        dataIndex: "attempt",
        title: "Attempt",
        width: 200,
      },
      {
        dataIndex: "verified_at",
        title: "Verified At",
        width: 200,
      },
      {
        dataIndex: "created_at",
        title: "Created At",
        width: 200,
      },
    ],
    []
  );

  return (
    <List
      headerButtons={({ defaultButtons }) => (
        <>
          {defaultButtons}
          <Form {...searchFormProps} layout="inline">
            <Form.Item name="q">
              <Input
                placeholder="Search by ..."
                onChange={(e) => {
                  setQuery(e.target.value);
                }}
              />
            </Form.Item>
            <SaveButton type="default" onClick={searchFormProps.form?.submit}>
              SEARCH
            </SaveButton>
          </Form>
          <Button type="primary" onClick={triggerExport}>
            EXPORT
          </Button>
        </>
      )}
    >
      <Table
        {...tableProps}
        bordered={true}
        rowKey="
        getRowId={(row) => row.otp_id"
        columns={columns}
        scroll={{ x: 1500 }}
        size="middle"
        pagination={{
          ...tableProps.pagination,
          position: ["bottomRight"],
          size: "default",
        }}
      ></Table>
    </List>
  );
};
